import * as React from 'react'
import { GridApi } from '@mui/x-data-grid-pro'
import { useLocation } from 'react-router-dom'
import { ExportCSVButton } from '@sales-center/components'
import { useSelector } from 'react-redux'

import { selectOpportunityPageState } from '@user/store/opportunity/slice'
import { selectDraftLeadPageState } from '@user/store/draftLeads'
import { selectLeadPageState } from '@user/store/lead'

type Props = {
  apiRef: React.MutableRefObject<GridApi>
  exportClickCallback: () => void
  disableInteraction: boolean
  exportFileName?: string
}
export const GridExportButton: React.FC<Props> = (props) => {
  const { exportClickCallback, disableInteraction, exportFileName } = props
  const { pathname } = useLocation()

  const getFileName = () => {
    if (exportFileName) return exportFileName
    if (pathname == '/leads') return 'Leads'
    if (pathname == '/pending-leads') return 'Pendingleads'
    return 'Opportunities'
  }

  const getSelector = () => {
    if (pathname == '/leads') return selectLeadPageState
    if (pathname == '/pending-leads') return selectDraftLeadPageState
    return selectOpportunityPageState
  }

  const { multipleServiceLocations } = useSelector(getSelector())

  return (
    <>
      <ExportCSVButton
        disableInteraction={disableInteraction}
        gridButton
        exportClickCallback={exportClickCallback}
        fileName={getFileName()}
        multipleServiceLocations={multipleServiceLocations}
      />
    </>
  )
}
